<template>
    <div>
        <div class="error-details-header">
            <i class="fas fa-triangle-exclamation"></i>
            <div>
                <div class="error-details-title title">O que deu errado?</div>
                <!--  <div class="error-details-sub">ID: {{ id }}</div> -->
            </div>
        </div>

        <ScrollBar :minHeight="190" :maxHeight="190">
            <ul class="error-list">
                <li v-for="(msg, i) in safeMessages" :key="i" class="error-item">
                    <i class="fas fa-info-circle"></i>
                    <span>{{ msg }}</span>
                </li>

                <li v-if="safeMessages.length === 0" class="error-item muted">
                    <i class="fas fa-info-circle"></i>
                    <span>Algo deu errado, mas não recebemos detalhes do servidor.</span>
                </li>
            </ul>
        </ScrollBar>

        <div class="text-center">
            <Button key="closeErrors" title="Fechar" classIcon="fa-solid fa-circle-xmark" color="white"
                backGroundColor="#6D757B" size="small" :clicked="() => $emit('close')" />
        </div>
    </div>
</template>

<script>
import ScrollBar from "@/ui/layout/ScrollBar.vue";
import Button from "@/ui/forms/Button";

export default {
    name: "ActionErrorContent",
    components: { ScrollBar, Button },
    props: {
        id: { type: [String, Number], required: true },
        index: { type: Number, default: -1 },
        messages: { type: Array, default: () => [] },
    },
    computed: {
        safeMessages() {
            return (this.messages || []).filter(Boolean);
        },
    },
};
</script>

<style scoped>
.error-details-header {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 12px;
    color: #dc2626;
}

.error-details-header i {
    font-size: 18px;
}

.error-details-title {
    font-weight: 500;
    color: #6b7280;
}

.error-details-sub {
    font-size: 12px;
    color: #6b7280;
}

.error-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.error-item {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    padding: 8px 10px;
    background: #fff7f7;
    border: 1px solid #fde2e2;
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 13px;
    color: #dc2626;
}

.error-item i {
    margin-top: 2px;
}

.error-item.muted {
    background: #f9fafb;
    border-color: #e5e7eb;
    color: #6b7280;
}
</style>
